import { Card, Row, Col } from "antd";

function CardComponent({ data }) {
  return (
    <Row gutter={[16, 16]} justify="start" style={{ marginTop: "16px" }}>
      {data?.map((item, index) => (
        <Col xs={24} sm={12} md={8} key={index}>
          <Card
            bodyStyle={{
              display: "flex",
              alignItems: "center",
              padding: "20px",
            }}
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <div
              style={{
                backgroundColor: "#f5f5f5",
                borderRadius: "50%",
                padding: "10px",
                marginRight: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {item?.icon}
            </div>
            <div>
              <h2 style={{ margin: 0, fontSize: "24px" }}>
                {item?.number || 0}
              </h2>
              <span style={{ color: "#555" }}>{item?.label}</span>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default CardComponent;
